module.exports = "https://www.gc-pro.gnp.com.mx/9b65b5deb3708f69f5813debbf780c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/close_24px.png
// module id = 8089
// module chunks = 0